import React, { useEffect, useState } from "react";
// APIモジュール
import API from "@aws-amplify/api";
import * as mutations from "../graphql/mutations";

import { Container, Typography } from "@material-ui/core";
const api_name = process.env.REACT_APP_API_NAME;

export default function Thankyou(props) {
  const userInfo = props.userInfo;
  const sessionId = props.match.params.session_id;
  const [customerId, setCustomerId] = useState();
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (sessionId && !customerId) {
      var query = {
        body: {
          sessionId: sessionId,
        },
      };
      getCheckoutSession(query).then((session) => {
        console.log(session);
        setCustomerId(session.customer);
        let amount_total = session.amount_total;
        let itemName = "";
        if (amount_total === 19800) {
          itemName = "1アカウント";
        } else if (amount_total === 4000) {
          itemName = "新規ショップ追加";
        }
        // Analytics
        window.gtag("event", "purchase", {
          value: amount_total,
          items: itemName,
        });
      });
    }
  }, [sessionId]);

  useEffect(() => {
    if (userInfo) {
      if (customerId && userInfo.id) {
        var input = {
          id: userInfo.id,
          customerId: customerId,
        };
        updateUserInfo(input);
      }
    }
  }, [customerId, userInfo]);

  const getCheckoutSession = (query) => {
    return new Promise(function (resolve, reject) {
      API.post(api_name, "/stripe/checkoutSession", query)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Graphqlレコード更新処理
  const updateUserInfo = (input) => {
    console.log(input);
    if (!updated) {
      API.graphql({
        query: mutations.updateUserInfo,
        variables: { input: input },
      })
        .then((res) => {
          console.log(res);
          setUpdated(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <React.Fragment>
      <Container style={{ marginTop: "24px" }}>
        <Typography variant="h1" align="center">
          決済ありがとう！
        </Typography>
      </Container>
    </React.Fragment>
  );
}
